<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card style="padding: 24px;">
      <v-container fluid grid-list-md>
        <v-row style="margin:0">
          <p class="text" style="font-size: 24px;">
            <b>
              Atención
            </b>
          </p>
          <p class="text">
            Se ha recibido un alerta de la imposibilidad de comunicación con el
            Cliente fuera en el domicilio.
          </p>
          <p class="text">
            Se recomienda esperar 15 minutos para poder lograr la comunicación
            con el cliente o comunicarse con los Operadores para un intento de
            comunicación mediante un número telefónico alternativo.
          </p>
          <p class="text">
            <b>
              Es necesario la toma de fotografías del lugar antes de retirarse
              del domicilio.
            </b>
          </p>
        </v-row>
        <v-row style="margin:0">
          <v-btn
            block
            color="rapired"
            dark
            @click="
              $emit('confirm-noanswer');
              $emit('close-dialog');
            "
            style="margin:24px 0"
            >TOMAR FOTOGRAFÍA</v-btn
          >
        </v-row>
        <v-row style="margin:0">
          <v-btn block color="secondary" @click="$emit('close-dialog')"
            >SEGUIR ESPERANDO</v-btn
          >
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean
  }
};
</script>

<style scoped>
.text {
  font-size: 11px;
}
@media (min-height: 540px) {
  .text {
    font-size: 12px;
  }
}
@media (min-height: 570px) {
  .text {
    font-size: 14px;
  }
}
@media (min-height: 640px) {
  .text {
    font-size: 15px;
  }
}
@media (min-height: 670px) {
  .text {
    font-size: 16px;
  }
}
@media (min-height: 700px) {
  .text {
    font-size: 17px;
  }
}
</style>
